module.exports = __webpack_public_path__ + "static/media/27OCHA16.5cc80b35.jpg";